export const CountryList = [
    {
        id: 'Afghanistan',
        name: 'Afghanistan',
        code: 'AF',
    },
    {
        id: 'Åland Islands',
        name: 'Åland Islands',
        code: 'AX',
    },
    {
        id: 'Albania',
        name: 'Albania',
        code: 'AL',
    },
    {
        id: 'Algeria',
        name: 'Algeria',
        code: 'DZ',
    },
    {
        id: 'American Samoa',
        name: 'American Samoa',
        code: 'AS',
    },
    {
        id: 'AndorrA',
        name: 'AndorrA',
        code: 'AD',
    },
    {
        id: 'Angola',
        name: 'Angola',
        code: 'AO',
    },
    {
        id: 'Anguilla',
        name: 'Anguilla',
        code: 'AI',
    },
    {
        id: 'Antarctica',
        name: 'Antarctica',
        code: 'AQ',
    },
    {
        id: 'Antigua and Barbuda',
        name: 'Antigua and Barbuda',
        code: 'AG',
    },
    {
        id: 'Argentina',
        name: 'Argentina',
        code: 'AR',
    },
    {
        id: 'Armenia',
        name: 'Armenia',
        code: 'AM',
    },
    {
        id: 'Aruba',
        name: 'Aruba',
        code: 'AW',
    },
    {
        id: 'Australia',
        name: 'Australia',
        code: 'AU',
    },
    {
        id: 'Austria',
        name: 'Austria',
        code: 'AT',
    },
    {
        id: 'Azerbaijan',
        name: 'Azerbaijan',
        code: 'AZ',
    },
    {
        id: 'Bahamas',
        name: 'Bahamas',
        code: 'BS',
    },
    {
        id: 'Bahrain',
        name: 'Bahrain',
        code: 'BH',
    },
    {
        id: 'Bangladesh',
        name: 'Bangladesh',
        code: 'BD',
    },
    {
        id: 'Barbados',
        name: 'Barbados',
        code: 'BB',
    },
    {
        id: 'Belarus',
        name: 'Belarus',
        code: 'BY',
    },
    {
        id: 'Belgium',
        name: 'Belgium',
        code: 'BE',
    },
    {
        id: 'Belize',
        name: 'Belize',
        code: 'BZ',
    },
    {
        id: 'Benin',
        name: 'Benin',
        code: 'BJ',
    },
    {
        id: 'Bermuda',
        name: 'Bermuda',
        code: 'BM',
    },
    {
        id: 'Bhutan',
        name: 'Bhutan',
        code: 'BT',
    },
    {
        id: 'Bolivia',
        name: 'Bolivia',
        code: 'BO',
    },
    {
        id: 'Bosnia and Herzegovina',
        name: 'Bosnia and Herzegovina',
        code: 'BA',
    },
    {
        id: 'Botswana',
        name: 'Botswana',
        code: 'BW',
    },
    {
        id: 'Bouvet Island',
        name: 'Bouvet Island',
        code: 'BV',
    },
    {
        id: 'Brazil',
        name: 'Brazil',
        code: 'BR',
    },
    {
        id: 'British Indian Ocean Territory',
        name: 'British Indian Ocean Territory',
        code: 'IO',
    },
    {
        id: 'Brunei Darussalam',
        name: 'Brunei Darussalam',
        code: 'BN',
    },
    {
        id: 'Bulgaria',
        name: 'Bulgaria',
        code: 'BG',
    },
    {
        id: 'Burkina Faso',
        name: 'Burkina Faso',
        code: 'BF',
    },
    {
        id: 'Burundi',
        name: 'Burundi',
        code: 'BI',
    },
    {
        id: 'Cambodia',
        name: 'Cambodia',
        code: 'KH',
    },
    {
        id: 'Cameroon',
        name: 'Cameroon',
        code: 'CM',
    },
    {
        id: 'Canada',
        name: 'Canada',
        code: 'CA',
    },
    {
        id: 'Cape Verde',
        name: 'Cape Verde',
        code: 'CV',
    },
    {
        id: 'Cayman Islands',
        name: 'Cayman Islands',
        code: 'KY',
    },
    {
        id: 'Central African Republic',
        name: 'Central African Republic',
        code: 'CF',
    },
    {
        id: 'Chad',
        name: 'Chad',
        code: 'TD',
    },
    {
        id: 'Chile',
        name: 'Chile',
        code: 'CL',
    },
    {
        id: 'China',
        name: 'China',
        code: 'CN',
    },
    {
        id: 'Christmas Island',
        name: 'Christmas Island',
        code: 'CX',
    },
    {
        id: 'Cocos (Keeling) Islands',
        name: 'Cocos (Keeling) Islands',
        code: 'CC',
    },
    {
        id: 'Colombia',
        name: 'Colombia',
        code: 'CO',
    },
    {
        id: 'Comoros',
        name: 'Comoros',
        code: 'KM',
    },
    {
        id: 'Congo',
        name: 'Congo',
        code: 'CG',
    },
    {
        id: 'Congo, The Democratic Republic of the',
        name: 'Congo, The Democratic Republic of the',
        code: 'CD',
    },
    {
        id: 'Cook Islands',
        name: 'Cook Islands',
        code: 'CK',
    },
    {
        id: 'Costa Rica',
        name: 'Costa Rica',
        code: 'CR',
    },
    {
        id: 'Cote D"Ivoire',
        name: 'Cote D"Ivoire',
        code: 'CI',
    },
    {
        id: 'Croatia',
        name: 'Croatia',
        code: 'HR',
    },
    {
        id: 'Cuba',
        name: 'Cuba',
        code: 'CU',
    },
    {
        id: 'Cyprus',
        name: 'Cyprus',
        code: 'CY',
    },
    {
        id: 'Czech Republic',
        name: 'Czech Republic',
        code: 'CZ',
    },
    {
        id: 'Denmark',
        name: 'Denmark',
        code: 'DK',
    },
    {
        id: 'Djibouti',
        name: 'Djibouti',
        code: 'DJ',
    },
    {
        id: 'Dominica',
        name: 'Dominica',
        code: 'DM',
    },
    {
        id: 'Dominican Republic',
        name: 'Dominican Republic',
        code: 'DO',
    },
    {
        id: 'Ecuador',
        name: 'Ecuador',
        code: 'EC',
    },
    {
        id: 'Egypt',
        name: 'Egypt',
        code: 'EG',
    },
    {
        id: 'El Salvador',
        name: 'El Salvador',
        code: 'SV',
    },
    {
        id: 'Equatorial Guinea',
        name: 'Equatorial Guinea',
        code: 'GQ',
    },
    {
        id: 'Eritrea',
        name: 'Eritrea',
        code: 'ER',
    },
    {
        id: 'Estonia',
        name: 'Estonia',
        code: 'EE',
    },
    {
        id: 'Ethiopia',
        name: 'Ethiopia',
        code: 'ET',
    },
    {
        id: 'Falkland Islands (Malvinas)',
        name: 'Falkland Islands (Malvinas)',
        code: 'FK',
    },
    {
        id: 'Faroe Islands',
        name: 'Faroe Islands',
        code: 'FO',
    },
    {
        id: 'Fiji',
        name: 'Fiji',
        code: 'FJ',
    },
    {
        id: 'Finland',
        name: 'Finland',
        code: 'FI',
    },
    {
        id: 'France',
        name: 'France',
        code: 'FR',
    },
    {
        id: 'French Guiana',
        name: 'French Guiana',
        code: 'GF',
    },
    {
        id: 'French Polynesia',
        name: 'French Polynesia',
        code: 'PF',
    },
    {
        id: 'French Southern Territories',
        name: 'French Southern Territories',
        code: 'TF',
    },
    {
        id: 'Gabon',
        name: 'Gabon',
        code: 'GA',
    },
    {
        id: 'Gambia',
        name: 'Gambia',
        code: 'GM',
    },
    {
        id: 'Georgia',
        name: 'Georgia',
        code: 'GE',
    },
    {
        id: 'Germany',
        name: 'Germany',
        code: 'DE',
    },
    {
        id: 'Ghana',
        name: 'Ghana',
        code: 'GH',
    },
    {
        id: 'Gibraltar',
        name: 'Gibraltar',
        code: 'GI',
    },
    {
        id: 'Greece',
        name: 'Greece',
        code: 'GR',
    },
    {
        id: 'Greenland',
        name: 'Greenland',
        code: 'GL',
    },
    {
        id: 'Grenada',
        name: 'Grenada',
        code: 'GD',
    },
    {
        id: 'Guadeloupe',
        name: 'Guadeloupe',
        code: 'GP',
    },
    {
        id: 'Guam',
        name: 'Guam',
        code: 'GU',
    },
    {
        id: 'Guatemala',
        name: 'Guatemala',
        code: 'GT',
    },
    {
        id: 'Guernsey',
        name: 'Guernsey',
        code: 'GG',
    },
    {
        id: 'Guinea',
        name: 'Guinea',
        code: 'GN',
    },
    {
        id: 'Guinea-Bissau',
        name: 'Guinea-Bissau',
        code: 'GW',
    },
    {
        id: 'Guyana',
        name: 'Guyana',
        code: 'GY',
    },
    {
        id: 'Haiti',
        name: 'Haiti',
        code: 'HT',
    },
    {
        id: 'Heard Island and Mcdonald Islands',
        name: 'Heard Island and Mcdonald Islands',
        code: 'HM',
    },
    {
        id: 'Holy See (Vatican City State)',
        name: 'Holy See (Vatican City State)',
        code: 'VA',
    },
    {
        id: 'Honduras',
        name: 'Honduras',
        code: 'HN',
    },
    {
        id: 'Hong Kong',
        name: 'Hong Kong',
        code: 'HK',
    },
    {
        id: 'Hungary',
        name: 'Hungary',
        code: 'HU',
    },
    {
        id: 'Iceland',
        name: 'Iceland',
        code: 'IS',
    },
    {
        id: 'India',
        name: 'India',
        code: 'IN',
    },
    {
        id: 'Indonesia',
        name: 'Indonesia',
        code: 'ID',
    },
    {
        id: 'Iran, Islamic Republic Of',
        name: 'Iran, Islamic Republic Of',
        code: 'IR',
    },
    {
        id: 'Iraq',
        name: 'Iraq',
        code: 'IQ',
    },
    {
        id: 'Ireland',
        name: 'Ireland',
        code: 'IE',
    },
    {
        id: 'Isle of Man',
        name: 'Isle of Man',
        code: 'IM',
    },
    {
        id: 'Israel',
        name: 'Israel',
        code: 'IL',
    },
    {
        id: 'Italy',
        name: 'Italy',
        code: 'IT',
    },
    {
        id: 'Jamaica',
        name: 'Jamaica',
        code: 'JM',
    },
    {
        id: 'Japan',
        name: 'Japan',
        code: 'JP',
    },
    {
        id: 'Jersey',
        name: 'Jersey',
        code: 'JE',
    },
    {
        id: 'Jordan',
        name: 'Jordan',
        code: 'JO',
    },
    {
        id: 'Kazakhstan',
        name: 'Kazakhstan',
        code: 'KZ',
    },
    {
        id: 'Kenya',
        name: 'Kenya',
        code: 'KE',
    },
    {
        id: 'Kiribati',
        name: 'Kiribati',
        code: 'KI',
    },
    {
        id: 'Korea, Democratic People"S Republic of',
        name: 'Korea, Democratic People"S Republic of',
        code: 'KP',
    },
    {
        id: 'Korea, Republic of',
        name: 'Korea, Republic of',
        code: 'KR',
    },
    {
        id: 'Kuwait',
        name: 'Kuwait',
        code: 'KW',
    },
    {
        id: 'Kyrgyzstan',
        name: 'Kyrgyzstan',
        code: 'KG',
    },
    {
        id: 'Lao People"S Democratic Republic',
        name: 'Lao People"S Democratic Republic',
        code: 'LA',
    },
    {
        id: 'Latvia',
        name: 'Latvia',
        code: 'LV',
    },
    {
        id: 'Lebanon',
        name: 'Lebanon',
        code: 'LB',
    },
    {
        id: 'Lesotho',
        name: 'Lesotho',
        code: 'LS',
    },
    {
        id: 'Liberia',
        name: 'Liberia',
        code: 'LR',
    },
    {
        id: 'Libyan Arab Jamahiriya',
        name: 'Libyan Arab Jamahiriya',
        code: 'LY',
    },
    {
        id: 'Liechtenstein',
        name: 'Liechtenstein',
        code: 'LI',
    },
    {
        id: 'Lithuania',
        name: 'Lithuania',
        code: 'LT',
    },
    {
        id: 'Luxembourg',
        name: 'Luxembourg',
        code: 'LU',
    },
    {
        id: 'Macao',
        name: 'Macao',
        code: 'MO',
    },
    {
        id: 'Macedonia, The Former Yugoslav Republic of',
        name: 'Macedonia, The Former Yugoslav Republic of',
        code: 'MK',
    },
    {
        id: 'Madagascar',
        name: 'Madagascar',
        code: 'MG',
    },
    {
        id: 'Malawi',
        name: 'Malawi',
        code: 'MW',
    },
    {
        id: 'Malaysia',
        name: 'Malaysia',
        code: 'MY',
    },
    {
        id: 'Maldives',
        name: 'Maldives',
        code: 'MV',
    },
    {
        id: 'Mali',
        name: 'Mali',
        code: 'ML',
    },
    {
        id: 'Malta',
        name: 'Malta',
        code: 'MT',
    },
    {
        id: 'Marshall Islands',
        name: 'Marshall Islands',
        code: 'MH',
    },
    {
        id: 'Martinique',
        name: 'Martinique',
        code: 'MQ',
    },
    {
        id: 'Mauritania',
        name: 'Mauritania',
        code: 'MR',
    },
    {
        id: 'Mauritius',
        name: 'Mauritius',
        code: 'MU',
    },
    {
        id: 'Mayotte',
        name: 'Mayotte',
        code: 'YT',
    },
    {
        id: 'Mexico',
        name: 'Mexico',
        code: 'MX',
    },
    {
        id: 'Micronesia, Federated States of',
        name: 'Micronesia, Federated States of',
        code: 'FM',
    },
    {
        id: 'Moldova, Republic of',
        name: 'Moldova, Republic of',
        code: 'MD',
    },
    {
        id: 'Monaco',
        name: 'Monaco',
        code: 'MC',
    },
    {
        id: 'Mongolia',
        name: 'Mongolia',
        code: 'MN',
    },
    {
        id: 'Montserrat',
        name: 'Montserrat',
        code: 'MS',
    },
    {
        id: 'Morocco',
        name: 'Morocco',
        code: 'MA',
    },
    {
        id: 'Mozambique',
        name: 'Mozambique',
        code: 'MZ',
    },
    {
        id: 'Myanmar',
        name: 'Myanmar',
        code: 'MM',
    },
    {
        id: 'Namibia',
        name: 'Namibia',
        code: 'NA',
    },
    {
        id: 'Nauru',
        name: 'Nauru',
        code: 'NR',
    },
    {
        id: 'Nepal',
        name: 'Nepal',
        code: 'NP',
    },
    {
        id: 'Netherlands',
        name: 'Netherlands',
        code: 'NL',
    },
    {
        id: 'Netherlands Antilles',
        name: 'Netherlands Antilles',
        code: 'AN',
    },
    {
        id: 'New Caledonia',
        name: 'New Caledonia',
        code: 'NC',
    },
    {
        id: 'New Zealand',
        name: 'New Zealand',
        code: 'NZ',
    },
    {
        id: 'Nicaragua',
        name: 'Nicaragua',
        code: 'NI',
    },
    {
        id: 'Niger',
        name: 'Niger',
        code: 'NE',
    },
    {
        id: 'Nigeria',
        name: 'Nigeria',
        code: 'NG',
    },
    {
        id: 'Niue',
        name: 'Niue',
        code: 'NU',
    },
    {
        id: 'Norfolk Island',
        name: 'Norfolk Island',
        code: 'NF',
    },
    {
        id: 'Northern Mariana Islands',
        name: 'Northern Mariana Islands',
        code: 'MP',
    },
    {
        id: 'Norway',
        name: 'Norway',
        code: 'NO',
    },
    {
        id: 'Oman',
        name: 'Oman',
        code: 'OM',
    },
    {
        id: 'Pakistan',
        name: 'Pakistan',
        code: 'PK',
    },
    {
        id: 'Palau',
        name: 'Palau',
        code: 'PW',
    },
    {
        id: 'Palestinian Territory, Occupied',
        name: 'Palestinian Territory, Occupied',
        code: 'PS',
    },
    {
        id: 'Panama',
        name: 'Panama',
        code: 'PA',
    },
    {
        id: 'Papua New Guinea',
        name: 'Papua New Guinea',
        code: 'PG',
    },
    {
        id: 'Paraguay',
        name: 'Paraguay',
        code: 'PY',
    },
    {
        id: 'Peru',
        name: 'Peru',
        code: 'PE',
    },
    {
        id: 'Philippines',
        name: 'Philippines',
        code: 'PH',
    },
    {
        id: 'Pitcairn',
        name: 'Pitcairn',
        code: 'PN',
    },
    {
        id: 'Poland',
        name: 'Poland',
        code: 'PL',
    },
    {
        id: 'Portugal',
        name: 'Portugal',
        code: 'PT',
    },
    {
        id: 'Puerto Rico',
        name: 'Puerto Rico',
        code: 'PR',
    },
    {
        id: 'Qatar',
        name: 'Qatar',
        code: 'QA',
    },
    {
        id: 'Reunion',
        name: 'Reunion',
        code: 'RE',
    },
    {
        id: 'Romania',
        name: 'Romania',
        code: 'RO',
    },
    {
        id: 'Russian Federation',
        name: 'Russian Federation',
        code: 'RU',
    },
    {
        id: 'RWANDA',
        name: 'RWANDA',
        code: 'RW',
    },
    {
        id: 'Saint Helena',
        name: 'Saint Helena',
        code: 'SH',
    },
    {
        id: 'Saint Kitts and Nevis',
        name: 'Saint Kitts and Nevis',
        code: 'KN',
    },
    {
        id: 'Saint Lucia',
        name: 'Saint Lucia',
        code: 'LC',
    },
    {
        id: 'Saint Pierre and Miquelon',
        name: 'Saint Pierre and Miquelon',
        code: 'PM',
    },
    {
        id: 'Saint Vincent and the Grenadines',
        name: 'Saint Vincent and the Grenadines',
        code: 'VC',
    },
    {
        id: 'Samoa',
        name: 'Samoa',
        code: 'WS',
    },
    {
        id: 'San Marino',
        name: 'San Marino',
        code: 'SM',
    },
    {
        id: 'Sao Tome and Principe',
        name: 'Sao Tome and Principe',
        code: 'ST',
    },
    {
        id: 'Saudi Arabia',
        name: 'Saudi Arabia',
        code: 'SA',
    },
    {
        id: 'Senegal',
        name: 'Senegal',
        code: 'SN',
    },
    {
        id: 'Serbia and Montenegro',
        name: 'Serbia and Montenegro',
        code: 'CS',
    },
    {
        id: 'Seychelles',
        name: 'Seychelles',
        code: 'SC',
    },
    {
        id: 'Sierra Leone',
        name: 'Sierra Leone',
        code: 'SL',
    },
    {
        id: 'Singapore',
        name: 'Singapore',
        code: 'SG',
    },
    {
        id: 'Slovakia',
        name: 'Slovakia',
        code: 'SK',
    },
    {
        id: 'Slovenia',
        name: 'Slovenia',
        code: 'SI',
    },
    {
        id: 'Solomon Islands',
        name: 'Solomon Islands',
        code: 'SB',
    },
    {
        id: 'Somalia',
        name: 'Somalia',
        code: 'SO',
    },
    {
        id: 'South Africa',
        name: 'South Africa',
        code: 'ZA',
    },
    {
        id: 'South Georgia and the South Sandwich Islands',
        name: 'South Georgia and the South Sandwich Islands',
        code: 'GS',
    },
    {
        id: 'Spain',
        name: 'Spain',
        code: 'ES',
    },
    {
        id: 'Sri Lanka',
        name: 'Sri Lanka',
        code: 'LK',
    },
    {
        id: 'Sudan',
        name: 'Sudan',
        code: 'SD',
    },
    {
        id: 'Suriname',
        name: 'Suriname',
        code: 'SR',
    },
    {
        id: 'Svalbard and Jan Mayen',
        name: 'Svalbard and Jan Mayen',
        code: 'SJ',
    },
    {
        id: 'Swaziland',
        name: 'Swaziland',
        code: 'SZ',
    },
    {
        id: 'Sweden',
        name: 'Sweden',
        code: 'SE',
    },
    {
        id: 'Switzerland',
        name: 'Switzerland',
        code: 'CH',
    },
    {
        id: 'Syrian Arab Republic',
        name: 'Syrian Arab Republic',
        code: 'SY',
    },
    {
        id: 'Taiwan, Province of China',
        name: 'Taiwan, Province of China',
        code: 'TW',
    },
    {
        id: 'Tajikistan',
        name: 'Tajikistan',
        code: 'TJ',
    },
    {
        id: 'Tanzania, United Republic of',
        name: 'Tanzania, United Republic of',
        code: 'TZ',
    },
    {
        id: 'Thailand',
        name: 'Thailand',
        code: 'TH',
    },
    {
        id: 'Timor-Leste',
        name: 'Timor-Leste',
        code: 'TL',
    },
    {
        id: 'Togo',
        name: 'Togo',
        code: 'TG',
    },
    {
        id: 'Tokelau',
        name: 'Tokelau',
        code: 'TK',
    },
    {
        id: 'Tonga',
        name: 'Tonga',
        code: 'TO',
    },
    {
        id: 'Trinidad and Tobago',
        name: 'Trinidad and Tobago',
        code: 'TT',
    },
    {
        id: 'Tunisia',
        name: 'Tunisia',
        code: 'TN',
    },
    {
        id: 'Turkey',
        name: 'Turkey',
        code: 'TR',
    },
    {
        id: 'Turkmenistan',
        name: 'Turkmenistan',
        code: 'TM',
    },
    {
        id: 'Turks and Caicos Islands',
        name: 'Turks and Caicos Islands',
        code: 'TC',
    },
    {
        id: 'Tuvalu',
        name: 'Tuvalu',
        code: 'TV',
    },
    {
        id: 'Uganda',
        name: 'Uganda',
        code: 'UG',
    },
    {
        id: 'Ukraine',
        name: 'Ukraine',
        code: 'UA',
    },
    {
        id: 'United Arab Emirates',
        name: 'United Arab Emirates',
        code: 'AE',
    },
    {
        id: 'United Kingdom',
        name: 'United Kingdom',
        code: 'GB',
    },
    {
        id: 'United States',
        name: 'United States',
        code: 'US',
    },
    {
        id: 'United States Minor Outlying Islands',
        name: 'United States Minor Outlying Islands',
        code: 'UM',
    },
    {
        id: 'Uruguay',
        name: 'Uruguay',
        code: 'UY',
    },
    {
        id: 'Uzbekistan',
        name: 'Uzbekistan',
        code: 'UZ',
    },
    {
        id: 'Vanuatu',
        name: 'Vanuatu',
        code: 'VU',
    },
    {
        id: 'Venezuela',
        name: 'Venezuela',
        code: 'VE',
    },
    {
        id: 'Viet Nam',
        name: 'Viet Nam',
        code: 'VN',
    },
    {
        id: 'Virgin Islands, British',
        name: 'Virgin Islands, British',
        code: 'VG',
    },
    {
        id: 'Virgin Islands, U.S.',
        name: 'Virgin Islands, U.S.',
        code: 'VI',
    },
    {
        id: 'Wallis and Futuna',
        name: 'Wallis and Futuna',
        code: 'WF',
    },
    {
        id: 'Western Sahara',
        name: 'Western Sahara',
        code: 'EH',
    },
    {
        id: 'Yemen',
        name: 'Yemen',
        code: 'YE',
    },
    {
        id: 'Zambia',
        name: 'Zambia',
        code: 'ZM',
    },
    {
        id: 'Zimbabwe',
        name: 'Zimbabwe',
        code: 'ZW',
    },
];
